import {useState} from "react";
import styled from "styled-components";
import { AiOutlineInstagram } from "react-icons/ai";
import { GiEarthAmerica } from "react-icons/gi";
import { FaLinkedinIn } from "react-icons/fa";
import { Slide } from "react-awesome-reveal";
import shailez from '../Images/shailez.jpg'
import About from "./about";
import Resume from '../Images/Shailesh-Budakoti-Resume.pdf';
import Header from "./Header";
import { border } from "@chakra-ui/react";

const ProfComponent = () => {
  const [bar, setBar] = useState(false);
  return (
    <>

    <Container id="home" style={{marginTop:"50px"}}  >
      <Slide direction="left">
        <Texts>
          <h4 style={{color:"white"}}>
            Hello <span className="green">I'am</span>
          </h4>
          <h1 className="green" id="user-detail-name" style={{color:"white"}}>Shailesh Kumar Budakoti</h1>
          <h3 style={{color:"white"}}>Full Stack Web Developer</h3>
          <p  style={{color:"white"}}>
          A passionate MERN Stack Developer. Developing websites using Javascript, React, Node JS, Express JS, and MongoDB. Looking forward to the opportunities that can bring challenges and learnings to leverage and hone skills.
          </p>
          <a href="geeksforgeeks.png" download="GFG">
          <div
        onClick={() => setBar(!bar)}
        className="bars">
            <div className="bar"></div>
       
          <button id="resume-button-2" onClick={()=>{
           window.open("https://1drv.ms/b/s!Amdy1B6DhXwuk4lCAWRv3QKTsnjmXw?e=pHuadB","_blank");
          }} ><a href={Resume} download={'SHAILESH-RESUME-DOWNLOAD'} target="_blank" id="resume-link-2" >Resume</a></button>
        </div>  </a>
         
          <Social>
            <p style={{color:"white"}}>Check out my</p>
            <div className="social-icons">
          
        
              <span>
                <a href="/">
                  <FaLinkedinIn />
                </a>
              </span>
            </div>
          </Social>
        </Texts>
      </Slide>
      <Slide direction="right">
        <Profile >
          <img className="home-img"
            src={shailez}
            alt="profile"
          />
        </Profile>
      </Slide>
    </Container>
    {/* <About/> */}
    </>
    
  );
};

export default ProfComponent;

const Container = styled.div`
  display: flex;
  gap: 2rem;
  padding-top: 3rem;
  width: 80%;
  max-width: 1280px;
  margin: 0 auto;
  z-index: 1;
  @media (max-width: 840px) {
    width: 90%;
  }

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;
const Texts = styled.div`
  flex: 1;
  h4 {
    padding: 1rem 0;
    font-weight: 500;
  }
  h1 {
    font-size: 2rem;
    font-family: "Secular One", sans-serif;
    letter-spacing: 2px;
  }
  h3 {
    font-weight: 500;
    font-size: 1.2rem;
    padding-bottom: 1.2rem;
    text-transform: capitalize;
  }
  p {
    font-weight: 300;
  }

  button {
    padding: 0.7rem 2rem;
    margin-top: 3rem;
    cursor: pointer;
    background-color: #01be96;
    border: none;
    color: #fff;
    font-weight: 500;
    filter: drop-shadow(0px 10px 10px #01be9551);
    :hover {
      filter: drop-shadow(0px 10px 10px #01be9570);
    }
  }
`;
const Social = styled.div`
  margin-top: 3rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  p {
    font-size: 0.9rem;
    @media (max-width: 690px) {
      font-size: 0.7rem;
    }
  }

  .social-icons {
    display: flex;
    align-items: center;
    gap: 1rem;
    span {
      width: 2.3rem;
      height: 2rem;
      clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
      background-color: #01be96;
      position: relative;
      transition: transform 400ms ease-in-out;
      :hover {
        transform: rotate(360deg);
      }
    }

    a {
      color: #fff;
      position: absolute;
      top: 55%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const Profile = styled.div`
  img {
    width: 20rem;
    border-radius:15px;
    filter: drop-shadow(0px 10px 10px #01be9570);
    transition: transform 400ms ease-in-out;
    @media (max-width: 790px) {
      width: 20rem;
    }

    @media (max-width: 660px) {
      width: 18rem;
    }

    @media (max-width: 640px) {
      width: 100%;
    }
  }

  :hover img {
    transform: translateY(-10px);
  }
`;
